import { useEffect } from 'react';
/**
 * Listens for "keypress" events and toggle keyboard-a11y class name
 * when user press "tab" (i.e: using keyboard navigation)
 *
 * Removes the class when users clicks on the screen.
 */

var useKeyboardNavigationFlag = function useKeyboardNavigationFlag() {
  var handleClick = function handleClick(_e) {
    var _document = document,
        body = _document.body;

    if (body) {
      body.classList.remove('keyboard-a11y');
      window.addEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClick);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    var _document2 = document,
        body = _document2.body;

    if (e.code === 'Tab') {
      body.classList.add('keyboard-a11y');
    }

    window.addEventListener('click', handleClick);
    window.removeEventListener('keydown', handleKeyDown);
  };

  useEffect(function () {
    var _document3 = document,
        body = _document3.body;
    var attr = 'listeningKeyboardNavigation'; // If the attribute isn't set yet, we set it and enable the listener
    // We want this check to avoid setting the same event handler multiple times

    if (!body.dataset[attr]) {
      body.dataset[attr] = 'true';
      window.addEventListener('keydown', handleKeyDown);
      return;
    }
  }, []);
};

export default useKeyboardNavigationFlag;